import { Icon } from "@iconify/react";
import { Link } from "react-router";
import pallete from "./pallete";

export const breadcrumbMap = {
  "/": { title: "Dashboard", icon: "hugeicons:home-04" },
  "/history-log": { title: "Riwayat Log", icon: "hugeicons:file-01" },
  "/history-log/detail/:id": { title: "Detail Riwayat Log", icon: "hugeicons:file-01" },
  "/profile": { title: "Profil", icon: "hugeicons:user-01" },
  "/bill-simulation": { title: "Simulasi Tagihan", icon: "hugeicons:calculator" },
  "/bill-simulation/customer-category": { title: "Kategori Pelanggan", icon: "hugeicons:users-group" },
  "/bill-simulation/maintenance-cost": { title: "Biaya Pemeliharaan", icon: "hugeicons:tools" },
  "/bill-simulation/fixed-cost": { title: "Biaya Tetap", icon: "hugeicons:money" },
  "/bill-simulation/cubication-cost": { title: "Biaya Kubikasi", icon: "hugeicons:chart-columns-01" },
  "/bill-simulation/cubication-cost/create": { title: "Tambah Biaya Kubikasi", icon: "hugeicons:add-circle" },
  "/bill-simulation/cubication-cost/detail/:id": { title: "Detail Biaya Kubikasi", icon: "hugeicons:file-search-01" },
  "/disturbance-information": { title: "Informasi Gangguan", icon: "hugeicons:warning-triangle" },
  "/disturbance-information/create": { title: "Tambah Informasi Gangguan", icon: "hugeicons:add-circle" },
  "/disturbance-information/detail/:id": { title: "Detail Informasi Gangguan", icon: "hugeicons:file-search-01" },
  "/contact": { title: "Kontak", icon: "hugeicons:contact-book-01" },
  "/contact/detail/:id": { title: "Detail Kontak", icon: "hugeicons:file-search-01" },
  "/banner": { title: "Banner", icon: "hugeicons:image-01" },
  "/banner/create": { title: "Tambah Banner", icon: "hugeicons:add-circle" },
  "/banner/detail/:id": { title: "Detail Banner", icon: "hugeicons:file-search-01" },
  "/customer-care": { title: "Layanan Pelanggan", icon: "hugeicons:customer-service" },
  "/customer-care/faq-category": { title: "Kategori FAQ", icon: "hugeicons:category" },
  "/customer-care/faq": { title: "FAQ", icon: "hugeicons:question-mark-circle" },
  "/customer-care/faq/create": { title: "Tambah FAQ", icon: "hugeicons:add-circle" },
  "/customer-care/faq/detail/:id": { title: "Detail FAQ", icon: "hugeicons:file-search-01" },
  "/customer-care/office": { title: "Kantor Layanan", icon: "hugeicons:building-01" },
  "/customer-care/office/create": { title: "Tambah Kantor Layanan", icon: "hugeicons:add-circle" },
  "/customer-care/office/detail/:id": { title: "Detail Kantor Layanan", icon: "hugeicons:file-search-01" },
  "/lab-service": { title: "Layanan Lab", icon: "hugeicons:flask" },
  "/lab-service/rate-per-commodity": { title: "Tarif per Komoditas", icon: "hugeicons:badge-dollar" },
  "/lab-service/rate-per-commodity/create": { title: "Tambah Tarif per Komoditas", icon: "hugeicons:add-circle" },
  "/lab-service/rate-per-commodity/detail/:id": { title: "Detail Tarif per Komoditas", icon: "hugeicons:file-search-01" },
  "/lab-service/rate-per-parameter": { title: "Tarif per Parameter", icon: "hugeicons:badge-dollar" },
  "/lab-service/rate-per-parameter/detail/:id": { title: "Detail Tarif per Parameter", icon: "hugeicons:file-search-01" },
  "/lab-service/other-rates": { title: "Tarif Lainnya", icon: "hugeicons:badge-dollar" },
  "/lab-service/other-rates/detail/:id": { title: "Detail Tarif Lainnya", icon: "hugeicons:file-search-01" },
  "/lab-service/testimony": { title: "Testimoni", icon: "hugeicons:badge-dollar" },
  "/lab-service/testimony/create": { title: "Tambah Testimoni", icon: "hugeicons:add-circle" },
  "/lab-service/testimony/detail/:id": { title: "Detail Testimoni", icon: "hugeicons:file-search-01" },
  "/master-data": { title: "Data Master", icon: "hugeicons:database-01" },
  "/master-data/user": { title: "Pengguna", icon: "hugeicons:user-01" },
  "/master-data/user/create": { title: "Tambah Pengguna", icon: "hugeicons:add-circle" },
  "/master-data/user/detail/:id": { title: "Detail Pengguna", icon: "hugeicons:file-search-01" },
  "/master-data/business-area": { title: "Area Bisnis", icon: "hugeicons:map-pin-marker" },
  "/master-data/business-area/create": { title: "Tambah Area Bisnis", icon: "hugeicons:add-circle" },
  "/master-data/business-area/detail/:id": { title: "Detail Area Bisnis", icon: "hugeicons:file-search-01" },
  "/master-data/reward": { title: "Reward", icon: "mdi:gift-outline" },
  "/master-data/reward/create": { title: "Tambah Reward", icon: "hugeicons:add-circle" },
  "/master-data/reward/detail/:id": { title: "Detail Reward", icon: "hugeicons:file-search-01" },

  "/water-tank": { title: "Air Tangki", icon: "game-icons:water-tank" },
  "/water-tank/detail/:id": { title: "Detail Air Tangki", icon: "hugeicons:master-data-type-01" },

  "/stand-meter": { title: "Stand Meter", icon: "ion:ios-speedometer" },
  "/stand-meter/detail/:id": { title: "Detail Stand Meter", icon: "hugeicons:master-data-type-01" },

  "/data-selection": { title: "Data Selection", icon: "hugeicons:database-01" },
  "/data-selection/data-selection-type": { title: "Kategorisasi", icon: "hugeicons:master-data-type-01" },
  "/data-selection/data-selection-type/detail/:id": { title: "Edit Kategorisasi", icon: "hugeicons:file-search-01" },
  "/data-selection/data-selection-item": { title: "Options", icon: "hugeicons:master-data-item-01" },

  "/rcc/payment-proof": { title: "Bukti Pembayaran RCC", icon: "hugeicons:file-01" },
  "/rcc/payment-proof/detail/:id": { title: "Detail Bukti Pembayaran RCC", icon: "hugeicons:file-search-01" },

  "/registration-pending": { title: "SR Masuk", icon: "hugeicons:time-clock-circle" },
  "/data-rcc": { title: "Data RCC", icon: "hugeicons:file-01" },
  "/data-rcc/detail/:id": { title: "Detail RCC", icon: "hugeicons:file-search-01" },
  "/registration": { title: "Monitoring SR", icon: "hugeicons:clipboard-check" },
  "/registration/detail/:id": { title: "Detail Monitoring SR", icon: "hugeicons:file-search-01" },
  "/registration/process": { title: "Sedang Diproses", icon: "hugeicons:rotate-clockwise" },
  "/registration/process/detail/:id": { title: "Detail Sedang Diproses", icon: "hugeicons:file-search-01" },
  "/registration/canceled": { title: "Data Tercancel", icon: "hugeicons:close-circle" },
  "/registration/canceled/detail/:id": { title: "Detail Registrasi Dibatalkan", icon: "hugeicons:file-search-01" },
  "/registration-finish": { title: "Data terpasang", icon: "hugeicons:check-circle" },
  "/registration-finish/detail/:id": { title: "Detail Data terpasang", icon: "hugeicons:file-search-01" },
  "/survey": { title: "Survei pelanggan", icon: "hugeicons:clipboard-check" },
  "/survey/detail/:id": { title: "Detail Survei", icon: "hugeicons:file-search-01" },
  "/survey/create": { title: "Tambah Survei", icon: "hugeicons:add-circle" },
  "/document-analysis": { title: "Analisis Berkas", icon: "hugeicons:file-text-01" },
  "/document-analysis/pending": { title: "Analisis Marketing", icon: "hugeicons:time-clock-circle" },
  "/document-analysis/pending/detail/:id": { title: "Detail Analisis Marketing", icon: "hugeicons:file-search-01" },
  "/document-analysis/process": { title: "Proses Analisis Dokumen", icon: "hugeicons:rotate-clockwise" },
  "/document-analysis/process/detail/:id": { title: "Detail Proses Analisis Dokumen", icon: "hugeicons:file-search-01" },
  "/document-analysis/canceled": { title: "Data Tercancel", icon: "hugeicons:close-circle" },
  "/document-analysis/canceled/detail/:id": { title: "Detail Data Tercancel", icon: "hugeicons:file-search-01" },
  "/document-analysis/detail/:id/officer": { title: "Detail Petugas Analisis Dokumen", icon: "hugeicons:file-search-01" },
};

/**
 * Extracts the path pattern from a full path by replacing actual IDs with :id placeholder
 * @param {string} path - The current path with actual IDs
 * @returns {string} - The path pattern with :id placeholders
 */
const getPathPattern = (path) => {
  // Split path by segments
  const segments = path.split("/").filter(Boolean);
  let pattern = "";

  // Identify numeric segments as IDs and replace with :id
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    // Check if segment is numeric (ID)
    if (/^\d+$/.test(segment)) {
      pattern += "/:id";
    } else {
      pattern += "/" + segment;
    }
  }

  return pattern || "/";
};

/**
 * Builds a path for breadcrumb navigation by replacing :id placeholders with actual ID values
 * @param {string} pathPattern - The path pattern with :id placeholders
 * @param {string} currentPath - The current full path with actual IDs
 * @returns {string} - The path with actual ID values
 */
const buildPathWithIds = (pathPattern, currentPath) => {
  // If no :id placeholder, return pattern as is
  if (!pathPattern.includes(":id")) {
    return pathPattern;
  }

  const patternSegments = pathPattern.split("/").filter(Boolean);
  const currentSegments = currentPath.split("/").filter(Boolean);

  // Safety check for mismatched segment lengths
  if (patternSegments.length !== currentSegments.length) {
    return pathPattern; // Return original pattern if segments don't match
  }

  let result = "";
  for (let i = 0; i < patternSegments.length; i++) {
    if (patternSegments[i] === ":id") {
      result += "/" + currentSegments[i];
    } else {
      result += "/" + patternSegments[i];
    }
  }

  return result;
};

/**
 * Generates breadcrumb items for the current location
 * @param {Object} location - The current location object
 * @returns {Array} - Array of breadcrumb items
 */
export const generateBreadcrumbItems = (location) => {
  // Get current path and prepare for breadcrumb generation
  const currentPath = location.pathname;

  // Always start with Dashboard
  const breadcrumbItems = [
    {
      key: "/",
      title: (
        <>
          <Icon
            icon="hugeicons:home-04"
            style={{ marginBottom: -3, marginRight: 5 }}
            width="16"
            height="16"
          />
          <Link to="/">Dashboard</Link>
        </>
      ),
    }
  ];

  // Get all parent paths
  const pathSegments = currentPath.split("/").filter(Boolean);

  // Find all parent paths that should appear in breadcrumb
  const parentPaths = [];
  let currentBuildPath = "";

  for (let i = 0; i < pathSegments.length; i++) {
    currentBuildPath += "/" + pathSegments[i];

    // Get the pattern for this path level
    const pattern = getPathPattern(currentBuildPath);

    // Find a matching entry in breadcrumbMap
    let matchFound = false;

    // Check if we have a direct match in breadcrumbMap
    if (breadcrumbMap[pattern]) {
      const config = breadcrumbMap[pattern];
      const actualPath = buildPathWithIds(pattern, currentBuildPath);

      parentPaths.push({
        path: actualPath,
        title: config.title,
        icon: config.icon,
        isLast: currentBuildPath === currentPath
      });

      matchFound = true;
    }

    // If no match and this is the last segment, create a default entry
    if (!matchFound && currentBuildPath === currentPath) {
      // Try to get the parent configuration
      const parentPattern = getPathPattern(currentBuildPath.split("/").slice(0, -1).join("/"));
      const parentConfig = breadcrumbMap[parentPattern] || {};

      parentPaths.push({
        path: currentBuildPath,
        title: `Detail ${pathSegments[i - 1] || ""}`,
        icon: "hugeicons:file-search-01",
        isLast: true
      });
    }
  }

  // Add parent paths to breadcrumb items
  parentPaths.forEach(({ path, title, icon, isLast }) => {
    breadcrumbItems.push({
      key: path,
      title: (
        <>
          <Icon
            icon={icon}
            style={{ marginBottom: -3, marginRight: 5 }}
            width="16"
            height="16"
          />
          {isLast ? (
            <span style={{ color: pallete.curiousBlue[600] }}>
              {title}
            </span>
          ) : (
            <Link to={path}>{title}</Link>
          )}
        </>
      ),
    });
  });

  return breadcrumbItems;
};